import { widget } from "@foretagsplatsen/widgetjs";

/**
 * `regionWidget` is a generic widget which `content` can be
 * dynamically updated.
 */
function regionWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	my.content = spec.content || (() => {});

	that.setContent = function (content) {
		my.content = content;
		that.update();
	};

	that.renderContentOn = function (html) {
		html.render(my.content);
	};

	return that;
}

export default regionWidget;
